module.exports = __webpack_public_path__ + "static/media/29BDOS11.cbb8a300.jpg";